import { styled } from '@mui/material/styles'
import MuiTextField from '@mui/material/TextField'

export const CustomTextField = styled(MuiTextField)((props) => ({
  width: '100%',
  '& label.Mui-focused': {
    color: '#555',
  },
  '& .MuiInput-underline:after': {
    background: 'linear-gradient(to right,#21d4fd,#b721ff)',
    height: '1px',
  },
  '& .MuiInputBase-root:after': {
    borderBottomColor: 'transparent'
  }
}));
